class MultiValuePropertyFilter {

    constructor() {

        this.filterHash;

        return (li, filter, partialMatch) => {
            if(!!li) {
                if("undefined" == typeof partialMatch || partialMatch == null || typeof partialMatch !== "boolean") {
                    partialMatch = false;
                }

                let filterKeys = Object.keys(filter);
                let arr = [];

                for (let l of li) {
                    let shouldAdd = true;
                    for (let k of filterKeys) {
                        let vals = filter[k];
                        if(partialMatch) {
                            if(Array.isArray(vals)) {
                                vals.filter(v => {
                                    return l[k].indexOf(v) > -1;
                                })
                                if(vals.length == -1) {
                                    shouldAdd = false;
                                    break;
                                }
                            }
                            else if(l[k].indexOf(vals) == -1) {
                                shouldAdd = false;
                                break;
                            }
                        }
                        else if (vals.length > 0 && vals.indexOf(l[k]) == -1) {
                            shouldAdd = false;
                            break;
                        }
                    }
                    if (shouldAdd) {
                        arr.push(l);
                    }
                }
                return arr;
            }

            return li;
        };
    }

}

angular.module('cpm')
    .filter('multiValuePropFilter', [() => {
        'use strict';
        return new MultiValuePropertyFilter();
    }]);
